import React from 'react';
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";


interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    pageSize: number;
    resetPageSize: (pageNumber: number, pageSize: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange, pageSize, resetPageSize }) => {
    const handlePageChange = (page: number) => {
        if (page > 0 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const Back = FiArrowLeft as any;
    const Forward = FiArrowRight as any;


    // Format page number to always have two digits (e.g., 01, 02, ... 10)
    const formatPageNumber = (num: number) => num.toString().padStart(2, '0');

    return (
        <div className="pagination_flx">
            <div className="pagesize_flx">
                <span className='font-semibold !text-gray-700'>Show</span>
                <Form.Select
                    className="sm_input"
                    value={pageSize}
                    onChange={(e) => {
                        resetPageSize(1, parseInt(e.target.value, 10));
                    }}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </Form.Select>
                <span>Entries</span>
            </div>

            <div className="pagination_right">
                <span>
                    <span className='font-semibold !text-gray-700'> Page :</span>  <span className="">{formatPageNumber(currentPage)}</span> of {totalPages}
                </span>
                {/* <div className="pagination_arrows">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination_arrow"
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination_arrow"
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div> */}
                <div className="flex border border-[#E6E6E6] rounded-lg overflow-hidden bg-white shadow-sm">

                    {/* Left Button */}
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="w-12 h-9 flex items-center justify-center border-r border-gray-200 
                           disabled:cursor-not-allowed text-sm"
                    >
                        <Back
                            size={20}
                            className={currentPage === 1 ? "text-gray-300" : "text-[#747474]"}
                        />{""}
                    </button>

                    {/* Right Button */}
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="w-12 h-9 flex items-center justify-center disabled:cursor-not-allowed text-sm"
                    >
                        <Forward
                            size={20}
                            className={currentPage === totalPages ? "text-gray-300" : "text-[#747474]"}
                        />{""}
                    </button>

                </div>

            </div>
        </div>
    );
};

export default Pagination;
